<div class="jumbotron jumbotron-fluid" style="background-image: url('assets/img/tablet.jpg');">
	<div class="bg-opacity"></div>
	<a href="/StatusBoxComponent"><i class="material-icons arrow-back">keyboard_backspace</i></a>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="text-center">
  					<h1 class="display-4">Pantallas del box</h1>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="container">
	<div class="row">
		<div class="col-12">			
			<div class="btn-wrapper-status">
				<a href="/IdleStateComponent" class="btn btn-primary btn-lg btn-status">Idle State</a>
				<a href="/BlackTLCDComponent" class="btn btn-primary btn-lg btn-status">Black State</a>
				<a href="/CheckGreenStateComponent" class="btn btn-primary btn-lg btn-status">CheckGreen State</a>
				<a href="/InfoPedidoComponent" class="btn btn-primary btn-lg btn-status">Ok Order State</a>
			</div>
		</div>		
	</div>
</div>